// API Configuration
export const API_BASE_URL = 'https://api.usepalmer.com';

export const API_ENDPOINTS = {
  LOGIN: '/users/login/',
  REGISTER: '/users/create/',
  LOGOUT: '/users/logout/',
  USERS: '/users/',
  CHAT: '/chat/',
  CHAT_BY_ID: (id) => `/chat/${id}/`,
  RESPONSE_RATING: '/response-rating/',
  WAITLIST: '/waitinglist/',
  // Add other endpoints here as needed
};

